import { FileBase64DTO, MediaStorageType } from "../models/models.swagger.generated";
import { MimeTypeHelper } from "./mime-type.helper";

export class FileDownloadHelper {
  public static downloadFile(fileDTO: FileBase64DTO): void {
    const link = this.createInvisibleDownloadLink(fileDTO);
    link.click();
  }

  public static createInvisibleDownloadLink(fileDTO: FileBase64DTO) {
    let source = fileDTO.contentBase64;
    if (!source.startsWith('data:')) {
      const mimeType = MimeTypeHelper.getMimeType(MediaStorageType[fileDTO.fileType]?.toLocaleLowerCase());
      source = `data:${mimeType};base64,${fileDTO.contentBase64}`;
    }
    const link = document.createElement('a');
    link.href = source;
    link.download = `${fileDTO.name}`;
    return link;
  }
}
